import EnumDataSource from "utils/enum-data-source.util";

const feedbackThumbUpRating = 1;
const feedbackThumbDownRating = 2;

const MEDICAL_SCRIBE_RATINGS = new EnumDataSource({
  [feedbackThumbUpRating]: "Thumb Up",
  [feedbackThumbDownRating]: "Thumb Down"
});

const feedbackSoapNoteType = 1;
const feedbackTranscriptType = 2;
const feedbackSummaryType = 3;

const MEDICAL_SCRIBE_FEEDBACK_TYPES = new EnumDataSource({
  [feedbackSoapNoteType]: "Soap Note",
  [feedbackTranscriptType]: "Transcript",
  [feedbackSummaryType]: "Summary"
});

export {
  MEDICAL_SCRIBE_RATINGS,
  MEDICAL_SCRIBE_FEEDBACK_TYPES,
  feedbackThumbUpRating,
  feedbackThumbDownRating,
  feedbackSoapNoteType,
  feedbackTranscriptType,
  feedbackSummaryType
};
